import { ref, watch, onBeforeMount, onBeforeUnmount, onDeactivated } from "vue"
import { useStore } from "vuex"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { utils } from "@/store/helpers"

export function useLayoutItemSharedLogic(
  props,
  postGetComponentRecord = () => {},
  additionalListeners = () => {},
  additionalUnListeners = () => {}
) {
  const loading = ref(false)
  const record_error = ref(false)
  const component_record = ref(null)

  // Get the Vuex store using Composition API
  const store = useStore()
  const emitter = store.$emitter // Assuming $emitter is globally registered via Vue app config

  // Register shared listeners
  const registerListeners = () => {
    emitter.on(ALL_EMITTERS.RECORD_UPDATED, (record) => {
      if (props.connectTo === "another_record" && record.id === props.linkedRecord) {
        component_record.value = record
      }
    })

    // Append additional listeners if provided
    additionalListeners()
  }

  const unregisterListeners = () => {
    additionalUnListeners()
    emitter.off(ALL_EMITTERS.RECORD_UPDATED)
  }

  onBeforeMount(registerListeners)
  onBeforeUnmount(unregisterListeners)
  onDeactivated(unregisterListeners)

  const getComponentRecord = () => {
    loading.value = !component_record.value
    return utils
      .getComponentRecord(props)
      .then((record) => {
        // Call the custom post-fetch logic if provided, and only for the first time
        if (!component_record.value) {
          component_record.value = record
          postGetComponentRecord()
        } else {
          component_record.value = record
        }

        loading.value = false
        record_error.value = false
      })
      .catch((err) => {
        record_error.value = true
        console.error(err)
      })
  }

  // Watch the store's state reactively
  watch(() => store.state.ui.currentCompany, getComponentRecord, { immediate: true })

  // Watch props
  watch(() => props.linkedRecord, getComponentRecord)
  watch(() => props.connectTo, getComponentRecord)

  return {
    loading,
    record_error,
    component_record,
    registerListeners,
    unregisterListeners
  }
}
